import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import db from "./Firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Moment from "moment";
import { extendMoment } from "moment-range";

function EnrolledCourse() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [personalDetails, setPersonalDetails] = useState({});

    useEffect(() => {
        // Fetch enrolled courses
        const unsubscribe = db.collection("nv_enrolled_courses")
            .orderBy("registered_date", "desc")
            .onSnapshot((snapshot) => {
                const courses = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));
                setData(courses);
                fetchPersonalDetails(courses); // Fetch names after courses are loaded
            });

        return () => unsubscribe();
    }, []);

    // **Fetch personal details for all phone numbers**
    const fetchPersonalDetails = async (courses) => {
        const phoneNumbers = [...new Set(courses.map(({ data }) => data.phone_no))];

        if (phoneNumbers.length === 0) return; // No phone numbers to fetch

        let detailsMap = {};
        const batchSize = 10; // Firestore 'in' query limit

        // **Fetch in batches of 10**
        for (let i = 0; i < phoneNumbers.length; i += batchSize) {
            const batch = phoneNumbers.slice(i, i + batchSize);
            const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));

            const snapshot = await getDocs(q);
            snapshot.docs.forEach((doc) => {
                const d = doc.data();
                detailsMap[d.phone_no] = d.full_name || "N/A"; // Default if missing
            });
        }

        setPersonalDetails(detailsMap);
    };

    // **Filter Data Based on Search Query**
    const filteredData = data.filter((record) =>
        record.data.phone_no.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3">
                    <h6 className="mb-2">Enrolled Course</h6>
                </div>

                <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search by Phone no"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />

                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Course Name</th>
                                <th>Course Tag</th>
                                <th>Phone No</th>
                                <th>Name</th>
                                <th>Course Price</th>
                                <th>Glow Price</th>
                                <th>Paid Amount</th>
                                <th>Registered Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map(({ id, data }, index) => (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td>{data.course_name}</td>
                                    <td>{data.course_tag}</td>
                                    <td>{data.phone_no}</td>
                                    <td>{personalDetails[data.phone_no] || "Loading..."}</td>
                                    <td>{data['course_price'].actual_price}</td>
                                    <td>{data['course_price'].membership_price}</td>
                                    <td>{data.amount ? data.amount : "Source"}</td>
                                    <td>{moment(data.registered_date.toDate()).format("DD/MM/YY, h:mm a")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default EnrolledCourse;



// import React, { useState, useEffect } from "react";


// import { useNavigate, Link, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2'
// import db from "./Firebase";
// import { storage } from './Firebase';
// import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import Moment from 'moment';
// import { extendMoment } from 'moment-range';

// function EnrolledCourse() {

//     const moment = extendMoment(Moment);
//     const [data, setData] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [personalDetails, setPersonalDetails] = useState({});

//     useEffect(() => {
//         db.collection("nv_enrolled_courses").orderBy("registered_date", "desc").onSnapshot((snapshot) => {
//             setData(
//                 snapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     data: doc.data(),
//                 }))
//             );
//         });

//     }, []);


//     // Step 3: Filter data based on search query and availability filter
//     const filteredData = data.filter((record) => {
//         return (
//             record.data.course_name.toLowerCase().includes(searchQuery.toLowerCase())
//         );
//     });

//     useEffect(() => {
//         // Extract unique phone numbers from enrolled courses data
//         const phoneNumbers = [...new Set(filteredData.map(({ data }) => data.phone_no))];

//         // Only proceed if we have phone numbers (and within Firestore's 'in' query limit)
//         if (phoneNumbers.length > 0 && phoneNumbers.length <= 10) {
//             const q = query(
//                 collection(db, "personal_details"),
//                 where("phone_no", "in", phoneNumbers)
//             );
//             getDocs(q)
//                 .then((snapshot) => {
//                     // Build a mapping from phone_no to name (assuming "name" is the field in personal_details)
//                     const detailsMap = {};
//                     snapshot.docs.forEach((doc) => {
//                         const d = doc.data();
//                         detailsMap[d.phone_no] = d.full_name;
//                     });
//                     setPersonalDetails(detailsMap);
//                 })
//                 .catch((err) => console.error("Error fetching personal details:", err));
//         }
//     }, [filteredData]);



//     const handleSearch = (e) => {
//         setSearchQuery(e.target.value); // Step 3: Update search query state
//     }


//     return (
//         <>
//             <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
//                 {/* <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span> */}
//                 <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

//             </div>

//             <div class="p-3">

//                 <div class="card-header pb-0 px-3">
//                     <h6 class="mb-2">Enrolled Course</h6>
//                 </div>
//                 <input
//                     type="text"
//                     className="form-control form-control-sm mb-2"
//                     placeholder="Search by Course Name"
//                     value={searchQuery}
//                     onChange={handleSearch}
//                 />


//                 <div class="table-responsive fix-width scroll-inner">
//                     <table class="table table-bordered table-hover">
//                         <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
//                             <tr>
//                                 <th>Sr. No</th>
//                                 <th>Course Name</th>
//                                 <th>Course Tag</th>
//                                 <th>Phone No</th>
//                                 <th>Name</th>
//                                 <th>Registered Date</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData?.map(({ id, data }, index) => (
//                                 <>
//                                     <tr>
//                                         <td>{index + 1}</td>
//                                         <td>{data.course_name}</td>
//                                         <td>{data.course_tag}</td>
//                                         <td>{data.phone_no}</td>
//                                         <td>{personalDetails[data.phone_no]}</td>
//                                         <td>{moment(data.registered_date.toDate().toISOString()).format("DD/MM/YY, h:mm a")}</td>
//                                     </tr>
//                                 </>
//                             ))}


//                         </tbody>
//                     </table>
//                 </div>
//             </div>



//         </>
//     )
// }

// export default EnrolledCourse